// extracted by mini-css-extract-plugin
module.exports = {"expandCollapseCopy":"ProfileActivityFeedToggle_expandCollapseCopy__y9obe"};